import {
	readProps,
	readStringList,
	stringProp,
} from "@productlane/lib/src/tiptap/extensions/mintlify/layout-props"
import {
	UPDATE_BLOCK,
	updateHtml,
} from "@productlane/lib/src/tiptap/extensions/mintlify/update-html"

import type { MdxBlockReader } from "./registry"

export const updateReaders: MdxBlockReader[] = [
	{
		name: "update",
		pattern: new RegExp(UPDATE_BLOCK.source, "g"),
		render: (match, parseBody) => {
			const props = readProps(match[1] ?? "")
			const body = match[2] ?? ""
			return updateHtml({
				label: stringProp(props, "label") ?? "",
				description: stringProp(props, "description") ?? "",
				tags: readStringList(stringProp(props, "tags")),
				contentHtml: body.trim() ? parseBody(body) : "",
			})
		},
	},
]
